import { getChangeRelatedGraph } from "./ticket_service";

export function createEmptyChangeContext() {
	return {
		problems: [],
		related_incidents: [],
		direct_relation_ids: {
			problems: {},
		},
		allowed_transitions: [],
		counts: {
			problems: 0,
			related_incidents: 0,
		},
	};
}

export function normalizeChangeRelatedGraph(payload) {
	return {
		problems: Array.isArray(payload?.problems) ? payload.problems : [],
		related_incidents: Array.isArray(payload?.related_incidents) ? payload.related_incidents : [],
		direct_relation_ids: {
			problems: payload?.direct_relation_ids?.problems || {},
		},
		allowed_transitions: Array.isArray(payload?.allowed_transitions) ? payload.allowed_transitions : [],
		counts: {
			problems: Number(payload?.counts?.problems || 0),
			related_incidents: Number(payload?.counts?.related_incidents || 0),
		},
	};
}

export async function getChangeContext(changeId) {
	const payload = await getChangeRelatedGraph(changeId);
	return normalizeChangeRelatedGraph(payload);
}
